const testimonials = [
  {
    name: "Dr. Patricia H.",
    location: "Monroe Medical District, LA",
    rating: 5,
    text: "I received a late-addition slot to a cardiology conference in Vienna with three weeks notice and my passport had expired during the COVID years when I was not traveling internationally. Fast Passport Center reviewed my documents, handled everything, and I had my renewed passport in five business days. Made my flight out of Dallas. Exceptional service for physicians who cannot afford to miss CME conferences.",
    service: "Passport Renewal",
  },
  {
    name: "James & Linda P.",
    location: "West Monroe, LA",
    rating: 5,
    text: "We booked a Caribbean cruise out of New Orleans for our anniversary and realized three weeks before sailing that I had never gotten a passport — I had always traveled domestically. Fast Passport Center guided me through the first-time applicant process, we went to the acceptance clerk in Monroe, shipped the next day, and I had my brand new passport in seven business days. Perfect timing. Highly recommend.",
    service: "New Passport",
  },
  {
    name: "Ethan N.",
    location: "Monroe, LA",
    rating: 5,
    text: "I am a ULM pharmacy student who was accepted to an international clinical rotation in Spain and had never obtained a passport. I did not know where to start. Fast Passport Center explained the acceptance clerk process clearly, told me exactly what to bring, and after my appointment we shipped same day. Had my passport in six business days with three weeks before my orientation departure. This service is why I made my program deadline.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function MonroeTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Northeast Louisiana Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Monroe, West Monroe, and Northeast Louisiana travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}